function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99984 1.99996C5.79317 1.99996 3.99984 3.79329 3.99984 5.99996H5.99984L3.33317 8.66663L0.666504 5.99996H2.6665C2.6665 3.05329 5.05317 0.666626 7.99984 0.666626C9.0465 0.666626 10.0198 0.973293 10.8398 1.49329L9.8665 2.46663C9.31317 2.16663 8.67317 1.99996 7.99984 1.99996ZM9.99999 5.99996L12.6667 3.33329L15.3333 5.99996H13.3333C13.3333 8.94663 10.9467 11.3333 7.99999 11.3333C6.95333 11.3333 5.97999 11.0266 5.15999 10.5066L6.13333 9.53329C6.68666 9.83329 7.32666 9.99996 7.99999 9.99996C10.2067 9.99996 12 8.20663 12 5.99996H9.99999Z",
  fill: "#121212"
});

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.6c53ab77.svg";
export { ForwardRef as ReactComponent };